var map = {
	"./cotton-1.png": [
		7912,
		912
	],
	"./cotton-10.png": [
		1063,
		63
	],
	"./cotton-11.png": [
		3548,
		548
	],
	"./cotton-12.png": [
		1558,
		558
	],
	"./cotton-2.png": [
		3753,
		753
	],
	"./cotton-3.png": [
		7416,
		416
	],
	"./cotton-4.png": [
		3397,
		397
	],
	"./cotton-5.png": [
		9049,
		49
	],
	"./cotton-6.png": [
		8909,
		909
	],
	"./cotton-7.png": [
		606,
		606
	],
	"./cotton-8.png": [
		9887,
		887
	],
	"./cotton-9.png": [
		9781,
		781
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9939;
module.exports = webpackAsyncContext;